/**
 * SOBV — Standard On Balance Volume.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLPriceAndVolume.cs, classe
 * FML.SOBV). Painel próprio, 1 linha, SEM parâmetros:
 *
 *   SOBV = SUM(IF(ISUP, VOL, IF(ISDOWN, −VOL, 0)), 0)     (soma CUMULATIVA)
 *
 * `ISUP`/`ISDOWN` do engine comparam fechamento × ABERTURA da MESMA barra
 * (`C>O` / `C<O`) — por isso SOBV ≠ `onBalanceVolume` do odin, que compara o
 * fechamento com o fechamento ANTERIOR. Paridade provada em
 * __tests__/sobv.silverlight.test.js.
 */
import { gt, lt, iff, mul, sum } from "./silverlightDsl";

export default function () {
  let options = {};

  function calculator(data) {
    const num = (v) => (Number.isFinite(v) ? v : NaN);
    const open = data.map((d) => num(d.open));
    const close = data.map((d) => num(d.close));
    // d.volume pode já ter sido processado pelo indicador Volume no mesmo
    // pipeline (applyIndicators roda em ordem): vira { volume, direction }.
    const vol = data.map((d) => {
      const raw = d.volume;
      return num(
        raw !== null && typeof raw === "object"
          ? Number(raw.volume)
          : Number(raw),
      );
    });

    const signed = iff(
      gt(close, open),
      vol,
      iff(lt(close, open), mul(vol, -1), 0),
    );
    const sobv = sum(signed, 0);

    return sobv.map((v) => (Number.isFinite(v) ? v : undefined));
  }

  calculator.undefinedLength = function () {
    return 0;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...x };
    return calculator;
  };

  return calculator;
}
